<div class="text-3xl font-bold tracking-normal">
	@if (timeRemaining() !== undefined) {
		<span>{{ timeRemaining() | date: 'mm:ss' }}</span>
	}
</div>
